module.exports = __webpack_public_path__ + "images/5a2f1089423f43d1a65e3f4d0ae9db2b42d6b4737edd66123549d7c51012886a.gif";